export const questionNumRegEx = /[qQ][0-9a-zA-Z-]+[.:]\s/;
export const numbersRegEx = /^[0-9]+$/;
export const digitsRegExp = /^[0-9]+$/;
export const timeStampRegExp = /^[0-9:,]{12}\s-->\s[0-9:,]{12}$/;
export const timeStringSeparatorRegExp = /\s-->\s/;
export const digit8RegExp = /\d{8}/g;
export const dateFormatsRegExp = /\d{1,2}[/,-,.]\d{1,2}[/,-,.]\d{2}(?:\d{2})?/g;
export const numAtEndRegExp = /\([0-9]+\)$/;
export const isABTestRegExp = /-[A-Z]{1}$/;
// eslint-disable-next-line
export const unicodeRegExp = /[^\x0a\x0d\x20-\x5F\x61-\x7E¡£¤¥§¿ÄÅÆÇÉÑÖØÜßàäåæèéìñòöøùüΓΔΘΛΞΠΣΦΨΩ€]/;
